import { FC, Suspense } from 'react'
import { BrowserRouter } from 'react-router-dom'

import {
  createTheme,
  CssBaseline,
  StyledEngineProvider,
  ThemeProvider,
} from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon'
import { InputGlobalStyles, Preloader } from '@procom-labs/atoms'
import {
  getLightThemeConfig,
  InjectableConfig,
  PaletteModeCode,
  TrackingProvider,
  WindowedObservable,
} from '@procom-labs/common'
import { RollbarProvider } from '@procom-labs/molecules'

import i18n from '@resume-portal/i18n'

import 'external-svg-loader'

import { muiTheme } from './config'
import { environment } from './environment'
import { AppRoutes } from './routes'

import './App.css'

import { axios } from './lib'

const gorillaResumeTheme = createTheme(
  muiTheme,
  getLightThemeConfig(PaletteModeCode.light),
  {
    palette: {
      divider: 'rgba(0, 0, 0, 0.20)',
    },
  }
)
new WindowedObservable(InjectableConfig.Axios).publish(axios)
new WindowedObservable(InjectableConfig.I18n).publish(i18n)

const App: FC<{}> = () => {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={gorillaResumeTheme}>
        <Suspense fallback={<Preloader center />}>
          <BrowserRouter>
            <CssBaseline />
            {InputGlobalStyles}
            <RollbarProvider>
              <TrackingProvider
                token={environment.MIXPANEL_TOKEN}
                pageTitlePrefix="GorillaResume"
              >
                <LocalizationProvider
                  dateAdapter={AdapterLuxon}
                  adapterLocale={i18n.language || 'en'}
                >
                  <AppRoutes />
                </LocalizationProvider>
              </TrackingProvider>
            </RollbarProvider>
          </BrowserRouter>
        </Suspense>
      </ThemeProvider>
    </StyledEngineProvider>
  )
}

export default App
